<template>
  <div>
    <RoutingPlanTabHeader
      v-model="filters.name.value"
      :is-refreshing="vm.isRefreshingPingTrees"
      :can-create-new="false"
      @refresh="vm.refreshPingTrees"
    />

    <div
      v-if="vm.pingTrees.length"
      class="grid_table_holder p-10"
    >
      <v-table
        :data="vm.pingTrees"
        :current-page.sync="currentPage"
        :page-size="10"
        :filters="filters"
        :hide-sort-icons="true"
        class="table_beauty table-condensed"
        cellpadding="0"
        cellspacing="0"
        @totalPagesChanged="totalPages = $event"
      >
        <thead slot="head">
          <tr>
            <v-th
              v-t="'CAMPAIGN_STEP_ROUTING_GROUPS_NAME'"
              align="left"
              class="column-sortable"
              sort-key="name"
              default-sort="asc"
            />
            <v-th
              v-t="'CAMPAIGN_STEP_ROUTING_GROUPS_TARGETS'"
              sort-key="targets"
              align="center"
              class="column-sortable"
            />
            <v-th
              v-t="'CAMPAIGN_STEP_ROUTING_GROUPS_STATUS'"
              sort-key="enabled"
              align="center"
              class="column-sortable"
            />
            <th
              v-t="'CAMPAIGN_STEP_ROUTING_GROUPS_ADD'"
              align="center"
            />
          </tr>
        </thead>
        <tbody
          slot="body"
          slot-scope="{ displayData }"
        >
          <tr
            v-for="tree in displayData"
            :key="tree.id"
            class="border_bottom"
          >
            <td align="left">
              <LinkedName
                :href="getHref('dashboard.ringtree.edit', { pingTreeId: tree.id, name: tree.name })"
                :title="tree.name"
              />
            </td>
            <td align="center">
              {{ tree.targets.length || 0 }}
            </td>
            <td align="center">
              <TargetStatus
                :entity="tree"
              />
            </td>
            <td align="center">
              <a
                href="javascript:;"
                class="btn btn-list-function typcn typcn-arrow-right-thick"
                @click.prevent="vm.openNewPingTreeRouteModal(tree)"
              />
            </td>
          </tr>
        </tbody>
      </v-table>
      <div class="pagination-min">
        <div class="text-center p-0">
          <smart-pagination
            :current-page.sync="currentPage"
            :total-pages="totalPages"
            :max-page-links="5"
          />
        </div>
      </div>
    </div><!--ending of grid_table_holder-->

    <LoadingStatusDisplay
      v-if="vm.isLoading"
      :loading="true"
    >
      {{ $t('CAMPAIGN_STEP_ROUTING_LOADING_PING_TREES') }}
    </LoadingStatusDisplay>
    <div
      v-else-if="!vm.pingTrees.length"
      class="col-xs-12"
    >
      {{ noTargetAvailableMessage }}
    </div>

    <template
      v-if="vm.modal != null"
    >
      <div
        v-if="vm.modal.type === 'new-ping-tree-route'"
        @click="vm.closeModal()"
      >
        TODO: New Ping Tree Route Modal (click to close)
        <br>
        templateUrl: 'scripts/shared/components/select-target/new-ping-tree-route.modal.html'
        <br>
        {{ vm.modal.target.name }}
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, reactive } from 'vue';
import RoutingPlanTabHeader from './RoutingPlanTabHeader.vue';
import { AvailablePingTreesViewModel } from '../models/AvailablePingTreesViewModel.js';
import LinkedName from '@/core/components/LinkedName/LinkedName.vue';
import TargetStatus from '@/core/components/Status/Status.vue';
import LoadingStatusDisplay from '@/core/components/Loader/LoadingStatusDisplay.vue';
import sharedMessages from '@/core/locales';
import messages from '../locales';

import {
  $ngStateService,
} from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default defineComponent({
  name: 'AvailablePingTrees',
  components: {
    RoutingPlanTabHeader,
    LinkedName,
    TargetStatus,
    LoadingStatusDisplay,
  },
  inject: {
    context: {
      from: 'routingPlansContext',
    },
  },
  data() {
    return {
      vm: reactive(new AvailablePingTreesViewModel()),
      currentPage: 1,
      totalPages: 0,
      filters: {
        name: {
          value: '',
          keys: ['number', 'phoneNumber', 'displayNumber', 'name', 'campaignName', 'publisherName'],
        },
      },
    };
  },
  computed: {
    noTargetAvailableMessage() {
      if (this.vm.hasAnyItem) {
        return this.$t('CAMPAIGN_STEP_ROUTING_ALL_TARGET_GROUPS_ASSIGNED');
      }

      return this.$t('CAMPAIGN_STEP_ROUTING_NONE_TARGET_GROUPS');
    },
  },
  methods: {
    getHref(state, params) {
      return $ngStateService.href(
        state,
        params,
        { absolute: true }
      );
    },
  },
  mounted() {
    this.vm.initialize(this.context);
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
});

</script>
